
//TODO: we should review and remove this. 
// I temporarily added this to fix the issue. 

// "address": {
//   "countryCode": "USA",
//   "countrySubdivisionCode": "MI", --> to fix this i added normalizeUsCountrySubdivisionCode function
//   "line2": "add2",
//   "line1": "123 test",
//   "line3": "add3",
//   "postalCode": "55305",
//   "city": "City"
// },

/**
 * Align `sender.address.countrySubdivisionCode` with
 * `sender.primaryIdentification.issueCountrySubdivisionCode` style (e.g. `US-NY`).
 *
 * For now: if the value is a 2-letter US state abbreviation, prefix with `US-`.
 * If it already starts with `US-`, normalize to `US-` + two-letter suffix.
 */
export function normalizeUsCountrySubdivisionCode(
  raw: string | null | undefined
): string {
  const s = (raw ?? "").trim().toUpperCase();
  if (!s) return "";
  if (s.startsWith("US-")) {
    const rest = s.slice(3).replace(/[^A-Z]/g, "");
    if (rest.length >= 2) return `US-${rest.slice(0, 2)}`;
    return s;
  }
  if (/^[A-Z]{2}$/.test(s)) return `US-${s}`;
  return s;
}

/** Two-letter suffix after `US-` for US-state picker matching (input may show `US-MI`). */
export function stripUsCountrySubdivisionPrefix(
  raw: string | null | undefined
): string {
  const v = (raw ?? "").trim().toUpperCase();
  if (v.startsWith("US-")) return v.slice(3);
  return v;
}
